// Libs
import type React from "react";

// Utils
import { useIntercom } from "src/hooks/useIntercom";
import { useDashboardLayoutStyles } from "./DashboardLayout.styles";

// Components
import { ErrorBoundary } from "src/components/Error/ErrorBoundary";
import { MarketingActionFeedbackBanner } from "src/components/MarketingActionFeedbackBanner/MarketingActionFeedbackBanner";
import { CapabilitiesProvider } from "src/contexts/CapabilitiesContext";
import { useRefiner } from "src/hooks/useRefiner";
import TopBar from "../SharedLayout/TopBar";

interface DashboardLayoutProps {
    children?: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
    const classes = useDashboardLayoutStyles();

    useIntercom();
    useRefiner();

    return (
        <CapabilitiesProvider>
            <div className={classes.root}>
                <TopBar />
                <MarketingActionFeedbackBanner />
                <ErrorBoundary>
                    <div className={classes.content}>{children}</div>
                </ErrorBoundary>
            </div>
        </CapabilitiesProvider>
    );
};
